import { Component, OnInit } from '@angular/core';
import {ActivatedRoute, Router} from '@angular/router';
import {LoaderService} from '@shared/services/loader.service';

@Component({
  selector: 'app-redirector',
  template: '',
})
export class RedirectorComponent implements OnInit {
    constructor(private route: ActivatedRoute, private router: Router, private loaderService: LoaderService) {}

    ngOnInit(): void {
        const destination = this.route.snapshot.queryParams['dest'];
        this.loaderService.show();
        if (destination) {
            setTimeout(() => {
                this.loaderService.hide();
                this.router.navigateByUrl(destination);
            }, 400);
        }
    }
}
